import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '../../Typography';
import { type PackCounterProps } from '../types';

const PackCounter : FC<PackCounterProps> = ({
  isSaleFinished,
  isSaleStarted,
  packsCount,
  packsLeft,
  packsSold,
}) => {
  const { t } = useTranslation();
  let text: string = t('wallet.packs.counter.default');
  if (!isSaleStarted) {
    text = t('wallet.packs.counter.total', { amount: packsCount || packsLeft && +(packsCount || packsLeft) });
  } else if (!isSaleFinished && packsLeft) {
    text = t('wallet.packs.counter.left', { amount: packsLeft });
  } else if (!isSaleFinished || packsSold) {
    text = t('wallet.packs.counter.sold', { amount: packsSold });
  }

  return (
    <Typography textColor="lightGray" size="captionSmall">
      {text}
    </Typography>
  );
};

export default PackCounter;
